<div class="container">
        <!--<div class="repMeta" *ngIf='rep'>  
            <img *ngIf="rep.PublicImageUrl != '' " height='78' width='75' src="https://extranet.securefreedom.com/Lbri/Personal/PersonalImages/{{rep.PublicImageUrl}}" />
            You are shopping with: <b>{{rep.DisplayName}}</b>
</div>-->
        <br />
        <div class="inventory-detail" *ngIf='detail && detail.length'>
                <div *ngFor='let det of detail'>
                        <div class="breadcrumbs hidden-xs hidden-sm">{{'productList.breadCrumbs' | translate}}
                                {{det.Description}}</div>
                        <br />
                        <div class="row">
                                <div class="col-xs-12 col-md-8 image_area">
                                        <div class="row">
                                                <div class="hidden-sm hidden-xs  col-md-4 image_area-small hidden"
                                                        [ngStyle]="{'background-image': 'url(https://extranet.securefreedom.com/lbri/Shopping/Images/' + det.SmallImage + ')'}">

                                                        <!-- <div class="hidden-sm hidden-xs  col-md-4 image_area-small"  [ngStyle]="{'background-image': 'url(https://extranet.securefreedom.com/lbri/Shopping/Images/' + detail.SmallImageURL + ')'}"> -->
                                                        <!---<img style="max-height: 152px; max-width: 120px;" src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{detail.SmallImageURL}}"/><br/>-->
                                                        &nbsp;
                                                </div>
                                                <div class="col-xs-12 col-md-8 image_area-large"
                                                        [ngStyle]="{'background-image': 'url(https://extranet.securefreedom.com/lbri/Shopping/Images/' + det.LargeImage + ')'}">

                                                        <!-- <div class="col-xs-12 col-md-8 image_area-large"  [ngStyle]="{'background-image': 'url(https://extranet.securefreedom.com/lbri/Shopping/Images/' + detail.LargeImageURL + ')'}"> -->
                                                        <!--<img src="https://extranet.securefreedom.com/lbri/Shopping/Images/{{detail.LargeImageURL}}" /><br/>-->
                                                        &nbsp;
                                                </div>

                                                <div align="left"><a [routerLink]="['/shop/from/', repId1]"
                                                                class='btn btn-primary btn-main btn-green'>
                                                                {{'productList.buttons.continueShopping' | translate}}
                                                        </a></div>

                                        <div
                                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 hidden-sm hidden-md hidden-lg hidden-xl hidden">
                                        <a class="btn btn-primary btn-main btn-green"
                                                [routerLink]="['/shop/from/', repId1]"><i class="fa fa-backward"
                                                        aria-hidden="true"></i>&nbsp;
                                                {{'productList.buttons.backToSampleSets' | translate}} </a></div>

                                        </div>


                                </div>


                                <div class="col-xs-12 col-md-4 meta_area">
                                        <div class="meta_area-name">{{det.Description}}</div>
                                        <div class="meta_area-sku">{{det.ProductID}}</div>
                                        <div class="meta_area-price">{{det.Price | currency:'USD':true:'1.2-2'}}</div>
                                        <!-- <div class="meta_area-name">{{detail.DisplayName}}</div>
                        <div class="meta_area-sku">{{detail.ProductID}}</div>
                        <div class="meta_area-price">{{detail.Price | currency:'USD':true:'1.2-2'}}</div> -->
                                        <div class="meta_area-separator">&nbsp;</div>
                                        <div align="right"><a
                                                        (click)="addProduct2(det.ProductID, det.Description, det.Price, det.SmallImage)"
                                                        class='btn btn-primary btn-main btn-block btn-green'>
                                                        {{'productList.buttons.AddToCart' | translate}} <i
                                                                class="fa fa-cart-plus"></i></a></div>
                                        <div class="meta_area-desc">
                                                <div class="meta_area-desc-header">{{'productList.titles.description' |
                                                        translate}}</div>
                                                <div class="meta_area-desc-content">
                                                        <div [innerHTML]="det.Explanation">{{det.Explanation}}</div>
                                                        <br />

                                                        <!-- <div [innerHTML]="detail.ShortDetail">{{detail.ShortDetail}}</div><br/> -->
                                                        <!-- [innerHTML]="detail.LongDetail" -->
                                                        <div [innerHTML]="det.LongExplanation">{{det.LongExplanation}}
                                                        </div><br />
                                                </div>
                                        </div>


                                        <!-- <simple-notifications [options]="options"></simple-notifications> -->
                                </div>


                                        <div
                                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 hidden-sm hidden-md hidden-lg hidden-xl hidden-big">
                                        <a class="btn btn-primary btn-main btn-green"
                                                [routerLink]="['/shop/from/', repId1]"><i class="fa fa-backward"
                                                        aria-hidden="true"></i>&nbsp;
                                                {{'productList.buttons.backToSampleSets' | translate}} </a></div>
                                
                        </div>
                </div>
        </div>